// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"highlight"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19 15H15V19M15.8839 15.8839L20 20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8.5 3H9.5M13.5 3H14.5M8.5 20H9.5M20 8.5V9.5M3 8.5V9.5M3 13.5V14.5M4.5 3H3V4.5M4.5 20H3V18.5M18.5 3H20V4.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const HighlightIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'highlight',
    ref,
    icon: element,
  },
));

HighlightIcon.displayName = 'HighlightIcon';

export default HighlightIcon;
